import Button from '@asphalt-react/button';
import React, { useEffect, useRef, useState } from 'react';
import placeholderIcon from '../../assets/placeholderIcon.svg';
import { Refresh, Undo } from '@asphalt-react/iconpack';
import { Image, Shimmer } from 'react-shimmer';
import styles from './AssetSelector.module.css';

function AssetSelector({
    onAssetSelected,
    asset,
    showResetToDefaultAction,
    disableResetToDefaultAction,
    onResetToDefualtActionClick,
    heading,
    darkBackground,
}) {
    const [assetSrc, setAssetSrc] = useState(null);
    useEffect(() => {
        setAssetSrc(asset);
    }, [asset]);

    const replaceButton = () => {
        return (
            <Button
                nude
                qualifier={<Refresh />}
                onClick={() => {
                    openImageSelector();
                }}>
                Replace
            </Button>
        );
    };

    const imageInput = useRef();

    const handleChange = (event) => {
        var file = event.target.files[0];
        event.target.value = '';
        if (file) {
            var fileReader = new FileReader();
            fileReader.onloadend = function (e) {
                if (file.type.indexOf('svg') > 0) {
                    setAssetSrc(fileReader.result);
                    onAssetSelected(file, fileReader.result);
                }
            };
            fileReader.readAsDataURL(file);
        }
    };

    const openImageSelector = () => {
        imageInput.current.click();
    };

    return (
        <div className={styles.imageDisplayerContainer}>
            <input
                type='file'
                onChange={handleChange}
                ref={imageInput}
                accept='.svg'
                draggable='true'
                className={styles.input}
            />
            <div className={styles.actionsContainer}>
                {assetSrc ? (
                    showResetToDefaultAction ? (
                        <>
                            <Button
                                nude
                                qualifier={<Undo />}
                                onClick={() => {
                                    onResetToDefualtActionClick();
                                }}
                                disabled={disableResetToDefaultAction}>
                                {'Reset to default'}
                            </Button>
                            {replaceButton()}
                        </>
                    ) : (
                        <>
                            <p className={styles.labelHeader}>{heading}</p>
                            {replaceButton()}
                        </>
                    )
                ) : (
                    <p className={styles.labelHeader}>{heading}</p>
                )}
            </div>
            <div className={`${styles.imageContainer} ${darkBackground ? styles.imageContainerDark : ''}`}>
                {assetSrc ? (
                    <Image
                        src={assetSrc}
                        className={styles.image}
                        NativeImgProps={{ alt: 'selected image' }}
                        fallback={<Shimmer width={360} height={240} />}
                    />
                ) : (
                    <div className={`${styles.placeholderContainer} ${darkBackground ? styles.placeholderContainerDark : ''}`}>
                        <img
                            src={placeholderIcon}
                            className={styles.placeholder}
                            alt={'placeholder'}
                        />
                        <Button
                            nude
                            onClick={() => {
                                openImageSelector();
                            }}>
                            Browse
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default AssetSelector;
